'use es6';

class RedirectError extends Error {
  constructor(message) {
    super(message || 'Rejecting because of redirect -- prevent promise until reload');
    this.name = 'RedirectError';
  }
}
export default RedirectError;